export default __webpack_public_path__ + "static/media/node-index.81079833.svg";